import $ from "jquery";

const Accessibility = () => {
	function init() {
		handleAccessibleFocus();
		handleSkipLink();
	}

	function handleSkipLink() {
		$(".skip-link").on("click", function (e) {
			e.preventDefault();
			const style = getCSSStyles();
			const finder = $(this).data("finder");
			if (finder === ".navigation") {
				setTimeout(function () {
					$("#accessibleStyle").html(style);
					$("li > a").first().trigger("focus");
				}, 250);
			}
			if (finder === "main") {
				setTimeout(function () {
					$("#accessibleStyle").html(style);
					$("main").find("a").first().trigger("focus");
				}, 250);
			}
		});
	}

	function handleAccessibleFocus() {
		const style = getCSSStyles();

		$("body").on("keydown", function () {
			$("#accessibleStyle").html(style);
		});

		$("body").on("click", function () {
			$("#accessibleStyle").html("");
		});
	}

	function getCSSStyles() {
		var style = "";
		style +=
			'a:focus, button:focus, input:focus, input[type="checkbox"]:focus+label, input[type="radio"]:focus+label, textarea:focus, select:focus, [tabindex="0"]:focus';
		style += "{";
		style += "outline: 3px solid #000 !important;";
		style += "box-shadow: none !important;";
		style += "outline-offset: -3px;";
		style += "}";

		style += ".post-and-event a:focus {";
		style += "outline: 3px solid #000000 !important;";
		style += "box-shadow: none !important;";
		style += "outline-offset: -3px;";
		style += "}";

		style += "a:focus img {";
		style += "outline: 3px solid #000000 !important;";
		style += "box-shadow: none !important;";
		style += "outline-offset: -3px;";
		style += "}";

		style += "a.primary-btn:focus {";
		style += "outline: 3px solid #000000 !important;";
		style += "box-shadow: none !important;";
		style += "outline-offset: -3px;";
		style += "}";

		style += "button.primary-btn:focus {";
		style += "outline: 3px solid #000000 !important;";
		style += "box-shadow: none !important;";
		style += "outline-offset: -3px;";
		style += "}";

		return style;
	}

	init();
};

export default Accessibility;
